<template>
  <div class="coverage-tracker">
    <div class="cov-head">
      <span>📊 维度覆盖度</span>
      <b :class="level">{{ coverage }}%</b>
    </div>
    <div class="cov-bar">
      <div class="cov-fill" :style="{ width: coverage + '%' }" :class="level" />
    </div>
    <div class="cov-legend">
      <span v-for="(d, i) in allDims" :key="i" class="cov-dot" :class="{ on: covered.includes(d) }">{{ d }}</span>
    </div>
  </div>
</template>

<script>
// 训练中实时追踪 OPQRST/SAMPLE 覆盖度
export default {
  name: 'CoverageTracker',
  props: {
    coverage: { type: Number, default: 0 },
    covered: { type: Array, default: () => [] },
  },
  data: () => ({ allDims: ['O', 'P', 'Q', 'R', 'S', 'T', 'A', 'M', 'P史', 'L', 'E'] }),
  computed: {
    level() { return this.coverage >= 80 ? 'high' : this.coverage >= 40 ? 'mid' : 'low'; },
  },
};
</script>

<style scoped>
.coverage-tracker { background: var(--bg-1); border: 1px solid var(--border-1); border-radius: var(--radius); padding: 14px; }
.cov-head { display: flex; justify-content: space-between; font-size: 12px; color: var(--text-2); margin-bottom: 8px; }
.cov-head b { font-size: 16px; }
.cov-head b.high { color: var(--success); }
.cov-head b.mid { color: var(--warn); }
.cov-head b.low { color: var(--text-3); }
.cov-bar { height: 10px; background: var(--sk-a); border-radius: 8px; overflow: hidden; }
.cov-fill { height: 100%; border-radius: 8px; transition: width 0.6s ease, background 0.3s; background: var(--grad-bar); }
.cov-fill.high { background: var(--success); }
.cov-legend { display: flex; gap: 6px; margin-top: 10px; flex-wrap: wrap; }
.cov-dot { font-size: 10px; padding: 2px 7px; border-radius: 4px; background: var(--bg-2); color: var(--text-3); border: 1px solid var(--border-1); transition: all 0.3s; }
.cov-dot.on { color: var(--success); border-color: var(--success-a40); background: var(--success-a07); }
</style>
